/* eslint-disable */
import React, { useEffect, useState } from 'react';
import styles from './costMaster.module.scss';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import StaffingCost from './StaffingCost/staffingCost';
import CloudCost from './CloudCost/cloudCost';
import SoftwareCost from './SoftwareCost/softwareCost';
import HardwareCost from './HardwareCost/hardwareCost';
import TravelCost from './TravelCost/travelCost';
import BACK_BUTTON from '../../Assets/images/svg/black_back_button.svg';
import { COST_MASTER } from '../../Constants/strings';


const CostMaster = () => {
  const [isMobileView, setIsMobileView] = useState(false);
  const [costValue, setCostValue] = useState('Staffing Cost');

  useEffect(() => {
    checkMobileView();
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (event, newValue) => {
    setCostValue(newValue);
  };

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth <= 1100);
  };

  const costDisplay = () => {
    switch (costValue) {
    case 'Staffing Cost':
      return <StaffingCost />;
    case 'Cloud Cost':
      return <CloudCost />;
    case 'Software Cost':
      return <SoftwareCost />;
    case 'Hardware Cost':
      return <HardwareCost />;
    case 'Travel Cost':
      return <TravelCost />;
    default:
      return <StaffingCost />;
    }
  };

    const getFontWeight = (value) => {
      return costValue === value ? '600' : '400';
    };


  return (
    <div className={styles['costDetails-container']}>
      <div className={styles['cost-header']}>
        <button
          type="button"
          className={styles['cost-master-back-button']}
          onClick={() => setCostValue('Staffing Cost')}
        >
          <img src={BACK_BUTTON} alt="back icon" />
        </button>
        <div className={styles['cost-mainText']}>{COST_MASTER.COST_MASTER}</div>
      </div>

      <Box className={styles['cost-tabs']}>
        <Tabs
          value={costValue}
          textColor={'#6B5CE8'}
          indicatorColor={'#6B5CE8'}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: '#6B5CE8',
            },
            '& .Mui-selected': {
              color: '#6B5CE8 !important',
            },
          }}
          aria-label="wrapped label tabs example"
        >
          <Tab
            value="Staffing Cost"
            label="Staffing Cost"
            sx={{
              minWidth: !isMobileView ? 200 : 'auto',
              textTransform: 'none',
              fontSize: !isMobileView ? 16 : 14,
              fontWeight: getFontWeight('Staffing Cost'),
            }}
          />
          <Tab
            value="Cloud Cost"
            label="Cloud Cost"
            sx={{
              minWidth: !isMobileView ? 200 : 'auto',
              textTransform: 'none',
              fontSize: !isMobileView ? 16 : 14,
              fontWeight: getFontWeight('Cloud Cost'),
            }}
          />
          <Tab
            value="Software Cost"
            label="Software Cost"
            sx={{
              minWidth: !isMobileView ? 200 : 'auto',
              textTransform: 'none',
              fontSize: !isMobileView ? 16 : 14,
              fontWeight: getFontWeight('Software Cost'),
            }}
          />
          <Tab
            value="Hardware Cost"
            label="Hardware Cost"
            sx={{
              minWidth: !isMobileView ? 200 : 'auto',
              textTransform: 'none',
              fontSize: !isMobileView ? 16 : 14,
              fontWeight: getFontWeight('Hardware Cost'),
            }}
          />
          <Tab
            value="Travel Cost"
            label="Travel Cost"
            sx={{
              minWidth: !isMobileView ? 200 : 'auto',
              textTransform: 'none',
              fontSize: !isMobileView ? 16 : 14,
              fontWeight: getFontWeight('Travel Cost'),
            }}
          />
        </Tabs>
      </Box>
      {costDisplay()}
    </div>
  );
};

export default CostMaster;
